import React, { useState } from "react";
import { ErrorMessage } from "@hookform/error-message";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";

import { Header, StatsPanel } from "../components";
import routes from "../routes/routes";
import { withAuthHeader } from "../routes/authRequest";

const AddEvents = () => {
    const { register, handleSubmit, errors } = useForm();
    const [message, setMessage] = useState("");
    const [image, setImage] = useState("")

    const mutation = useMutation(eventData => withAuthHeader.post(routes.api.locations.addEvent, eventData))
    const history = useHistory()

    let handleImageChange = (e) => {
        e.preventDefault()
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length)
            return;
        if ((e.target.files[0].size / 1024 / 1024) > 1) {
            // console.log("");
            setMessage("file too large")
            return
        } else {
            createImage(files[0], e.target.name);

        }
    }
    let createImage = (file, name) => {
        let reader = new FileReader();
        reader.onload = (e) => {
            setImage(e.target.result)
        };
        reader.readAsDataURL(file);
    }
    const onSubmit = async (inputData) => {
        // console.log("formData >>> ", formData)
        console.log({...inputData, image: image});
        // console.log("image>>> ", image);
        
        await mutation.mutate({...inputData, image: image}, {
            onSuccess: async (inputData) => {
                setMessage(["Event Added"])
                console.log("response", inputData);
                setTimeout(() => {
                    history.push(routes.public.events)
                }, 2000);

            },
            onError: async (error) => {
                setMessage(["Something went wrong, please try again"])
            },
        })
        
    };
    return (
        <div className="mainpanel">
            {/* <!-- pageheader --> */}
            <Header />

            <div className="contentpanel">

                <div className="col-md-10 col-md-offset-1">
                    <form className="panel panel-default" onSubmit={handleSubmit(onSubmit)}>
                        <p className="text-success">{message[0]}</p>

                        <div className="panel-heading">
                            <div className="panel-btns">
                                <a
                                    href="/#"
                                    className="panel-minimize tooltips"
                                    data-toggle="tooltip"
                                    title="Minimize Panel"
                                >
                                    <i className="fa fa-minus">-</i>
                                </a>
                                <a
                                    href="/#"
                                    className="panel-close tooltips"
                                    data-toggle="tooltip"
                                    title="Close Panel"
                                >
                                    <i className="fa fa-times"></i>
                                    X
                </a>
                            </div>
                            {/* <!-- panel-btns --> */}
                            <h4 className="panel-title">Create Event</h4>
                            <p>Add a new event by filling and submitting the form.</p>
                        </div>
                        {/* <!-- panel-heading --> */}
                        <div className="panel-body">
                            <div className="row">
                                <div className="form-group col-md-6">
                                    <label>Title</label>
                                    <input
                                        type="text"
                                        name="title"
                                        placeholder="Title"
                                        className="form-control"
                                        ref={register({
                                            required: "This input is required.",
                                        })}
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="title"
                                        render={(messages) => {
                                            console.log("messages", messages);
                                            return messages
                                                ? Object.entries(messages).map(([type, message]) => (
                                                    <p className="text-danger">{message}</p>
                                                ))
                                                : null;
                                        }}
                                    />
                                </div>

                                <div className="form-group col-md-6">
                                    <label>Category</label>
                                    <input
                                        type="text"
                                        name="category"
                                        placeholder="Category"
                                        defaultValue="Celebration"
                                        className="form-control"
                                        ref={register()}
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="category"
                                        render={(messages) => {
                                            console.log("messages", messages);
                                            return messages
                                                ? Object.entries(messages).map(([type, message]) => (
                                                    <p className="text-danger">{message}</p>
                                                ))
                                                : null;
                                        }}
                                    />
                                </div>
                                <div className="form-group col-md-12">
                                    <label>Address</label>
                                    <input
                                        type="text"
                                        name="address"
                                        placeholder="Address"
                                        className="form-control"
                                        defaultValue="Lagos Country Club"
                                        ref={register({
                                            required: "This input is required.",
                                        })}
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="address"
                                        render={(messages) => {
                                            console.log("messages", messages);
                                            return messages
                                                ? Object.entries(messages).map(([type, message]) => (
                                                    <p className="text-danger">{message}</p>
                                                ))
                                                : null;
                                        }}
                                    />
                                </div>
                                <div className="form-group col-md-6">
                                    <label>Start Date</label>
                                    <div className="input-group">
                                        <input
                                            type="date"
                                            className="form-control hasDatepicker"
                                            placeholder="mm/dd/yyyy"
                                            id="datepicker"
                                            name="start_date"
                                            ref={register({
                                                required: "This input is required.",
                                            })}
                                        />
                                        <span className="input-group-addon">
                                            <i className="glyphicon glyphicon-calendar"></i>
                                        </span>
                                    </div>
                                    <ErrorMessage
                                        errors={errors}
                                        name="start_date"
                                        render={(messages) => {
                                            console.log("messages", messages);
                                            return messages
                                                ? Object.entries(messages).map(([type, message]) => (
                                                    <p className="text-danger">{message}</p>
                                                ))
                                                : null;
                                        }}
                                    />
                                </div>
                                <div className="form-group col-md-6">
                                    <label>End Date</label>
                                    <div className="input-group">
                                        <input
                                            type="date"
                                            className="form-control hasDatepicker"
                                            placeholder="mm/dd/yyyy"
                                            id="datepicker"
                                            name="end_date"
                                            ref={register({
                                                required: "This input is required.",
                                            })}
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="end_date"
                                            render={(messages) => {
                                                console.log("messages", messages);
                                                return messages
                                                    ? Object.entries(messages).map(([type, message]) => (
                                                        <p className="text-danger">{message}</p>
                                                    ))
                                                    : null;
                                            }}
                                        />
                                        {/* <span className="input-group-addon">
                                            <i className="glyphicon glyphicon-calendar"></i>
                                        </span> */}
                                    </div>
                                </div>

                                <div className="form-group col-md-12">
                                    <label>Image</label>
                                    <div className="input-group">
                                        <input
                                            accept="image/*"
                                            className={"form-control"}
                                            id="post-image"
                                            onChange={handleImageChange}
                                            name="image"
                                            type="file"
                                            ref={register({
                                                required: "This input is required.",
                                            })}
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="image"
                                            render={(messages) => {
                                                console.log("messages", messages);
                                                return messages
                                                    ? Object.entries(messages).map(([type, message]) => (
                                                        <p className="text-danger">{message}</p>
                                                    ))
                                                    : null;
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* <!-- row --> */}

                            <label>Description</label>
                            <textarea
                                className="form-control"
                                name="description"
                                rows="5"
                                placeholder="Description"
                                ref={register({
                                    required: "This input is required.",
                                    minLength: {
                                        value: 10,
                                        message: "This input must exceed 10 characters",
                                    }
                                })}
                            ></textarea>
                            <ErrorMessage
                                errors={errors}
                                name="description"
                                render={(messages) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p className="text-danger">{message}</p>
                                        ))
                                        : null;
                                }}
                            />
                        </div>
                        {/* <!-- panel-body --> */}
                        <div className="panel-footer">
                            <button type="submit" className="btn btn-primary">Add Event</button>
                        </div>
                        {/* <!-- panel-footer --> */}
                    </form>
                    {/* <!-- panel --> */}
                </div>
            </div>
        </div>
    );
};

export default AddEvents;
